import React from "react";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select as MUISelect } from '@mui/material';
import { getAddressGroup } from "../../../services/appService";
import geoService from "../../../services/geoService";
import countryCodes from "../../../services/countryCodes.json";
import {
    allStateCountyCityReceived, getDataTypeDropdwonItems,
    getFormAllCountryStates, getFormAllStateCountyCity
} from "../../store/bprmForm";
import { useDispatch, useSelector } from "react-redux";

export default function Dropdown(props) {
    const { controleId,
        comp,
        stateData: data,
        stateErrors: errors,
        isDisabled,
        ddTypeCodMngr,
        setDdTypeCodMngr,
        handeOnChange,
        handleChange,
        setIsCountryStateChanged
    } = props;
    const allStatesSelector = useSelector(getFormAllCountryStates);
    const allStateCountyCitySelector = useSelector(getFormAllStateCountyCity);

    const dispatch = useDispatch();

    const getCodemangerOption = (id) => {
        if (ddTypeCodMngr) {
            const ddType = ddTypeCodMngr.filter((x) => x.controlId === id);
            return (
                ddType?.length > 0 &&
                ddType[0].optionData?.map((d, key) => (
                    <MenuItem key={key} value={d.name} data-code={d.code}>{d.name}</MenuItem>
                ))
            );
        }
    };

    const handleCustomChange = async ({ currentTarget: select }) => {
        const selectedItem = select.selectedOptions[0];
        const nextAttribute = select.dataset.childattribute;
        const nextType = nextAttribute.split(".");
        try {
            const items = getDataTypeDropdwonItems(nextType);
            const filterData = items.filter(
                (x) => x.parentCode === parseInt(selectedItem.dataset.code)
            );
            const ddTypeObj = { controlId: nextAttribute, optionData: filterData };
            const removeOldData = ddTypeCodMngr.filter(
                (x) => x.controlId !== nextAttribute
            );
            const addedType = [...removeOldData, ddTypeObj];
            handleChange({ ...select, type: "dropdown" });
            setDdTypeCodMngr(addedType);
            handleOnChangeTrigger(nextAttribute);
        } catch (err) {
            console.log(err);
        }
    };

    const handleOnChangeTrigger = (id) => {
        var element = document.getElementById(id);
        if (element) {
            var event = new Event("change", { bubbles: true });
            element.dispatchEvent(event);
        }

    }

    const handleDropdownValueChange = ({ currentTarget }) => {
        // const { ddTypeCodMngr, data, errors } = this.state;
        // const ddType = ddTypeCodMngr.filter(
        //   (x) => x.controlId === currentTarget.id
        // );
        // if (ddType.length > 0) {
        //   const filter = ddType[0].optionData.filter((x) => {
        //     return x.name.match(new RegExp(`${currentTarget.value}`, "gi"));
        //   });
        //   if (filter.length === 0) {
        //     data[currentTarget.id] = currentTarget.value;
        //     errors[currentTarget.id] = "Not Found";
        //   } else {
        //     data[currentTarget.id] = currentTarget.value;
        //     errors[currentTarget.id] = "";
        //   }

        //   this.setState({ data, errors });
        // }
    };

    const handleDropdownShowHide = (id, label) => {
        // if (id !== undefined) {
        //   const { ddTypeCodMngr } = this.state;
        //   const ddType = ddTypeCodMngr.filter((x) => x.controlId === id);
        //   this.setState({
        //     dropdownShowHide: !this.state.dropdownShowHide,
        //     dropdwonTitle: label,
        //     selectedDropdwonData: ddType,
        //   });
        // } else {
        //   this.setState({
        //     dropdownShowHide: !this.state.dropdownShowHide,
        //     dropdwonTitle: "",
        //     selectedDropdwonData: [],
        //   });
        // }
    };

    const handleCountryOnChange = ({ target: select }) => {
        handleChange({ ...select, type: "dropdown" });
        const allSelectedCountry = getCountryListById("", "");
        if (allSelectedCountry.length > 0) {
            const selectedCountry = allSelectedCountry.filter(x => x.countryName === select.value);
            if (selectedCountry.length > 0)
                bindCountryDropdown(selectedCountry[0].geonameId, select);
        }
        if (setIsCountryStateChanged)
            setIsCountryStateChanged(true);
    };

    const bindCountryDropdown = async (geonameId, select) => {
        const stateList = geonameId > 0 ? await geoService.getGeoData(geonameId) : [];
        const ddName = select.name.split(".")[0];
        const compId = select.name;
        let stList = allStateCountyCitySelector.filter(x => x.ddType === ddName);
        if (stList.length > 0) {
            const stObj = stList[0].stateObjects.filter(x => x.compId === controleId);
            const ctObj = stList[0].countyObjects;
            const cctObj = stList[0].cityObjects;
            let childCompId = "";
            if (stObj.length > 0) {
                const upSt = stList[0].stateObjects.map(c => {
                    if (c.name === data[select.name] && c.compId === controleId) {
                        const nc = { ...c }
                        nc.name = select.value;
                        nc.list = stateList;
                        nc.id = parseInt(geonameId);
                        nc.compId = compId;
                        childCompId = nc.childCompId;
                        return nc;
                    }
                    else {
                        return c
                    }
                })
                let childCompId1 = "";
                const upCt = ctObj.map(x => {
                    let nx = { ...x };
                    if (x?.compId === childCompId) {
                        nx.list = [];
                        childCompId1 = nx.childCompId;
                    }
                    return nx;
                })

                const upCct = cctObj.map(x => {
                    let nx = { ...x };
                    if (x?.compId === childCompId1) {
                        nx.list = [];
                    }
                    return nx;
                })

                let newUpdateStates = [...allStateCountyCitySelector];
                newUpdateStates = newUpdateStates.filter(x => x.ddType === ddName).map(a => {
                    const xa = { ...a };
                    xa.stateObjects = upSt;
                    xa.countyObjects = upCt;
                    xa.cityObjects = upCct;
                    return xa;
                });
                dispatch(allStateCountyCityReceived(newUpdateStates));
            }
            else {
                const sCode = stList[0].countryList.filter((x) => x.countryName === select?.value);
                if (sCode.length > 0 && comp?.childAttributeType) {
                    const childCompId2 = comp.childAttributeType.toLowerCase() + "." + comp.childAttributeObject;
                    const stNewObj = {
                        name: sCode[0].countryName,
                        list: stateList,
                        id: sCode[0].geonameId,
                        compId: controleId,
                        childCompId: childCompId2
                    }

                    let newUpdateStates = [...allStateCountyCitySelector];
                    newUpdateStates = newUpdateStates.filter(x => x.ddType === ddName).map(a => {
                        const xa = { ...a };
                        xa.stateObjects = [...xa.stateObjects, stNewObj];
                        //xa.countyObjects = [];
                        //xa.cityObjects = [];
                        return xa;
                    });
                    dispatch(allStateCountyCityReceived(newUpdateStates));
                }
            }
        }
    }

    const handleStateOnChange = ({ target: select }) => {
        handleChange({ ...select, type: "dropdown" });
        const allSelectedStates = getStateListByCountry(select.value, select.name);
        if (allSelectedStates.length > 0) {
            const selectedStates = allSelectedStates.filter(x => x.name === select.value);
            if (selectedStates.length > 0)
                bindCountyDropdown(selectedStates[0].geonameId, select);
        }
        if (setIsCountryStateChanged)
            setIsCountryStateChanged(true);
    };

    const bindCountyDropdown = async (geonameId, select) => {
        const countyList = geonameId > 0 ? await geoService.getGeoData(geonameId) : [];
        const ddName = select.name.split(".")[0];
        const compId = select.name;
        let stList = allStateCountyCitySelector.filter(x => x.ddType === ddName);
        if (stList.length > 0) {
            const stObj = stList[0].stateObjects;
            const ctObj = stList[0].countyObjects.filter(x => x?.compId === controleId);
            const cctObj = stList[0].cityObjects;
            let childCompId = "";
            if (ctObj.length > 0) {
                const upSt = stList[0]?.countyObjects.map(c => {
                    if (c?.name === data[select.name] && c?.compId === controleId) {
                        const nc = { ...c }
                        nc.name = select.value;
                        nc.list = countyList;
                        nc.id = parseInt(geonameId);
                        nc.compId = compId
                        childCompId = nc.childCompId;
                        return nc;
                    }
                    else {
                        return c
                    }
                })

                const upCct = cctObj.map(x => {
                    let nx = { ...x };
                    if (x?.compId === childCompId) {
                        nx.list = [];
                    }
                    return nx;
                })

                let newUpdateStates = [...allStateCountyCitySelector];
                newUpdateStates = newUpdateStates.filter(x => x?.ddType === ddName).map(a => {
                    const xa = { ...a };
                    xa.countyObjects = upSt;
                    xa.cityObjects = upCct;
                    return xa;
                });
                dispatch(allStateCountyCityReceived(newUpdateStates));
            }
            else {
                const sCode = stObj.filter((x) => x?.childCompId === controleId);
                if (sCode.length > 0) {
                    const ssObj = sCode[0]?.list.filter(x => x?.name === select?.value);
                    if (ssObj.length > 0 && comp?.childAttributeType) {
                        const childCompId1 = comp.childAttributeType.toLowerCase() + "." + comp.childAttributeObject;
                        const ctObj = {
                            name: select.value,
                            list: countyList,
                            id: ssObj[0].geonameId,
                            compId: controleId,
                            childCompId: childCompId1
                        }
                        let newUpdateStates = [...allStateCountyCitySelector];
                        newUpdateStates = newUpdateStates.filter(x => x.ddType === ddName).map(a => {
                            const xa = { ...a };
                            xa.countyObjects = [...xa.countyObjects, ctObj];
                            //xa.cityObjects = [];
                            return xa;
                        });
                        dispatch(allStateCountyCityReceived(newUpdateStates));
                    }
                }
            }
        }
    }

    const handleCountyOnChange = ({ target: select }) => {
        handleChange({ ...select, type: "dropdown" });
        const allSelectedCounty = getCountyListByState(select.value, select.name);
        if (allSelectedCounty.length > 0) {
            const selectedCounty = allSelectedCounty.filter(x => x.name === select.value);
            if (selectedCounty.length > 0)
                bindCityDropdown(selectedCounty[0].geonameId, select);
        }
        if (setIsCountryStateChanged)
            setIsCountryStateChanged(true);
    };

    const bindCityDropdown = async (geonameId, select) => {
        const cityList = geonameId > 0 ? await geoService.getGeoData(geonameId) : [];
        const ddName = select.name.split(".")[0];
        const compId = select.name;
        let stList = allStateCountyCitySelector.filter(x => x?.ddType === ddName);
        if (stList.length > 0) {
            const ctObj = stList[0].countyObjects;
            const stObj = stList[0].cityObjects.filter(x => x?.compId === controleId);
            if (stObj.length > 0) {
                const upSt = stList[0].cityObjects.map(c => {
                    if (c.name === data[select.name] && c?.compId === controleId) {
                        const nc = { ...c }
                        nc.name = select.value;
                        nc.list = cityList;
                        nc.id = parseInt(geonameId);
                        nc.compId = compId
                        return nc;
                    }
                    else {
                        return c
                    }
                })

                let newUpdateStates = [...allStateCountyCitySelector];
                newUpdateStates = newUpdateStates.filter(x => x?.ddType === ddName).map(a => {
                    const xa = { ...a };
                    xa.cityObjects = upSt;
                    return xa;
                });
                dispatch(allStateCountyCityReceived(newUpdateStates));
            }
            else {
                const sCode = ctObj.filter((x) => x.childCompId === controleId);
                if (sCode.length > 0) {
                    const ssObj = sCode[0].list.filter(x => x?.name === select?.value);
                    if (ssObj.length > 0 && comp?.childAttributeType) {
                        const childCompId1 = comp.childAttributeType.toLowerCase() + "." + comp.childAttributeObject;
                        const ctObj = {
                            name: select.value,
                            list: cityList,
                            id: ssObj[0].geonameId,
                            compId: controleId,
                            childCompId: childCompId1
                        }
                        let newUpdateStates = [...allStateCountyCitySelector];
                        newUpdateStates = newUpdateStates.filter(x => x?.ddType === ddName).map(a => {
                            const xa = { ...a };
                            xa.cityObjects = [...xa.cityObjects, ctObj];
                            return xa;
                        });
                        dispatch(allStateCountyCityReceived(newUpdateStates));
                    }
                }
            }
        }
    }

    const getCountryListById = (name, compId) => {
        const attName = comp.attributeType?.toLowerCase();
        const ctList = allStateCountyCitySelector.filter(x => x.ddType === attName);
        let countryList = [];
        if (ctList.length > 0) {
            countryList = ctList[0].countryList;
        }
        return countryList;
    }

    const getStateListByCountry = (name, childCompId) => {
        if (comp.addressGroup === "apiusstatecounty") {
            const usStateList = geoService.getStateList();
            return usStateList;
        }
        const attName = comp.attributeType?.toLowerCase();
        const stList = allStateCountyCitySelector.filter(x => x.ddType === attName);
        let stateList = [];
        if (stList.length > 0) {
            const stObj = stList[0].stateObjects?.filter(x => x.childCompId === childCompId);
            if (stObj?.length > 0) {
                stObj.map(c => {
                    c.list.map(s => {
                        if (s.name === name) {
                            stateList = c.list;
                            return;
                        }
                    })
                })

                if (stateList.length === 0) {
                    stateList = stObj[0].list;
                }
            }
        }
        return stateList;
    }

    const getCountyListByState = (name, childCompId) => {
        if (!name) return [];
        const attName = comp.attributeType?.toLowerCase();
        const ctList = allStateCountyCitySelector.filter(x => x.ddType === attName);
        let countyList = [];
        if (ctList.length > 0) {
            const stObj = ctList[0].countyObjects?.filter(x => x.childCompId === childCompId);
            if (stObj?.length > 0) {
                stObj.map(c => {
                    c.list.map(s => {
                        if (s.name === name) {
                            countyList = c.list;
                            return;
                        }
                    })
                })

                if (countyList.length === 0) {
                    countyList = stObj[0].list;
                }
            }
        }
        return countyList;
    }

    const getCityListByCounty = (name, childCompId) => {
        if (!name) return [];
        const attName = comp.attributeType?.toLowerCase();
        const ctList = allStateCountyCitySelector.filter(x => x.ddType === attName);

        let cityList = [];
        if (ctList.length > 0) {
            const stObj = ctList[0].cityObjects?.filter(x => x.childCompId === childCompId);
            if (stObj?.length > 0) {
                stObj.map(c => {
                    c.list.map(s => {
                        if (s.name?.toString() === name) {
                            cityList = c.list;
                            return;
                        }
                    })
                })

                if (cityList.length === 0) {
                    cityList = stObj[0].list;
                }
            }
        }
        return cityList;
    }

    const handeDropOnChange = ({ target }) => {
        handeOnChange({ target: { name: target.name, value: target.selectedOptions[0].value } })
    }

    let selectField = "";
    if (comp?.dropdownType === "search") {
        selectField = (
            <div className="d-flex">
                <input
                    type="text"
                    className="form-control mr-2"
                    name={controleId}
                    id={controleId}
                    value={!data[controleId] ? "" : data[controleId]}
                    onChange={handleDropdownValueChange}
                />
                <button
                    className="btn btn-outline-default"
                    onClick={() => handleDropdownShowHide(controleId, comp.label)}
                >
                    <i className="fa fa-search"></i>
                </button>
            </div>
        );
    }

    if (comp.dropdownType === "countrycode") {
        selectField = (
            <MUISelect
                name={controleId}
                value={!data[controleId] ? "" : data[controleId]}
                label={comp.label}
                disabled={isDisabled}
                onChange={(event) => handeOnChange({ target: { name: controleId, value: event.target.value, type: "dropdown" } })}
                sx={{
                    fontSize: "14px",
                    fontFamily: "Open Sans, sans-serif",
                    fontWeight: 400,
                    color: "#000000",
                    marginBottom: '18px',
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#555555",
                        color: "#555555",
                        opacity: 0.9,
                    },
                    "& .MuiInputLabel-root.Mui-disabled": {
                        color: "#333333",
                        opacity: 1,
                    },
                }}
            >
                <MenuItem
                    key={0}
                    value=""
                    sx={{
                        fontSize: "14px",
                        fontFamily: "Open Sans, sans-serif",
                        fontWeight: 400,
                        color: "#000000",
                    }}
                >Select</MenuItem>
                {countryCodes.map((item, key) => {
                    return <MenuItem
                        key={key}
                        value={item.dial_code + "_" + item.code}
                        sx={{
                            fontSize: "14px",
                            fontFamily: "Open Sans, sans-serif",
                            fontWeight: 400,
                            color: "#000000",
                        }}
                    >{item.dial_code} {item.name}</MenuItem>
                })}
            </MUISelect>
        );
    }
    else {
        selectField = <MUISelect
            name={controleId}
            value={!data[controleId] ? "" : data[controleId]}
            label={comp.label}
            disabled={isDisabled}
            onChange={(event) => comp?.childAttributeType ? handleCustomChange(event) : handeOnChange({ target: { name: controleId, value: event.target.value, type: "dropdown" } })}
            data-childattribute={comp.childAttributeType?.toLowerCase() + "." + comp.childAttributeObject}
            sx={{
                fontSize: "14px",
                fontFamily: "Open Sans, sans-serif",
                fontWeight: 400,
                color: "#000000",
                marginBottom: '18px',
                "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: "#555555",
                    color: "#555555",
                    opacity: 0.9,
                },
                "& .MuiInputLabel-root.Mui-disabled": {
                    color: "#333333",
                    opacity: 1,
                },
            }}

        >
            <MenuItem
                key={0}
                value=""
                sx={{
                    fontSize: "14px",
                    fontFamily: "Open Sans, sans-serif",
                    fontWeight: 400,
                    color: "#000000",
                }}
            >None</MenuItem>
            {comp?.dropdownvalue.filter((x) => x.name !== "").length > 0
                ? comp?.dropdownvalue.map((d, key) => <MenuItem
                    key={key}
                    value={d.value}
                    sx={{
                        fontSize: "14px",
                        fontFamily: "Open Sans, sans-serif",
                        fontWeight: 400,
                        color: "#000000",
                    }}
                >{d.name}</MenuItem>) : getCodemangerOption(controleId)}
        </MUISelect>
    }

    const adGroup = getAddressGroup();
    if (adGroup.indexOf(comp.addressGroup) > -1) {
        if (comp.addressObjList === "country") {
            let countryList = getCountryListById(data[controleId], controleId);
            selectField = <MUISelect
                name={controleId}
                value={!data[controleId] ? "" : data[controleId]}
                label={comp.label}
                onChange={handleCountryOnChange}
                disabled={isDisabled}
                sx={{
                    fontSize: "14px",
                    fontFamily: "Open Sans, sans-serif",
                    fontWeight: 400,
                    color: "#000000",
                    marginBottom: '18px',
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#555555",
                        color: "#555555",
                        opacity: 0.9,
                    },
                    "& .MuiInputLabel-root.Mui-disabled": {
                        color: "#333333",
                        opacity: 1,
                    },
                }}
            >
                <MenuItem
                    key={0}
                    value=""
                    sx={{
                        fontSize: "14px",
                        fontFamily: "Open Sans, sans-serif",
                        fontWeight: 400,
                        color: "#000000",
                    }}
                >None</MenuItem>
                {countryList.map((s, key) => {
                    return <MenuItem
                        key={key}
                        value={s.countryName}
                        data-geonameid={s.geonameId}
                        sx={{
                            fontSize: "14px",
                            fontFamily: "Open Sans, sans-serif",
                            fontWeight: 400,
                            color: "#000000",
                        }}
                    >{s.countryName}</MenuItem>
                })}
            </MUISelect>
        }
        if (comp.addressObjList === "state") {
            let stateList = [];
            stateList = getStateListByCountry(data[controleId], controleId);
            selectField = <MUISelect
                name={controleId}
                value={!data[controleId] ? "" : data[controleId]}
                label={comp.label}
                onChange={handleStateOnChange}
                disabled={isDisabled}
                sx={{
                    fontSize: "14px",
                    fontFamily: "Open Sans, sans-serif",
                    fontWeight: 400,
                    color: "#000000",
                    marginBottom: '18px',
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#555555",
                        color: "#555555",
                        opacity: 0.9,
                    },
                    "& .MuiInputLabel-root.Mui-disabled": {
                        color: "#333333",
                        opacity: 1,
                    },
                }}
            >
                <MenuItem
                    key={0}
                    value=""
                    sx={{
                        fontSize: "14px",
                        fontFamily: "Open Sans, sans-serif",
                        fontWeight: 400,
                        color: "#000000",
                    }}
                >None</MenuItem>
                {stateList.map((s, key) => {
                    return <MenuItem
                        key={key}
                        value={s.name}
                        data-geonameid={s.geonameId}
                        sx={{
                            fontSize: "14px",
                            fontFamily: "Open Sans, sans-serif",
                            fontWeight: 400,
                            color: "#000000",
                        }}
                    >{s.name}</MenuItem>
                })}
            </MUISelect>
        }
        if (comp.addressObjList === "county") {
            let countyList = [];
            countyList = getCountyListByState(data[controleId], controleId);
            selectField = <MUISelect
                name={controleId}
                value={!data[controleId] ? "" : data[controleId]}
                label={comp.label}
                onChange={handleCountyOnChange}
                disabled={isDisabled}
                sx={{
                    fontSize: "14px",
                    fontFamily: "Open Sans, sans-serif",
                    fontWeight: 400,
                    color: "#000000",
                    marginBottom: '18px',
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#555555",
                        color: "#555555",
                        opacity: 0.9,
                    },
                    "& .MuiInputLabel-root.Mui-disabled": {
                        color: "#333333",
                        opacity: 1,
                    },
                }}
            >
                <MenuItem
                    key={0}
                    value=""
                    sx={{
                        fontSize: "14px",
                        fontFamily: "Open Sans, sans-serif",
                        fontWeight: 400,
                        color: "#000000",
                    }}
                >None</MenuItem>
                {countyList.map((s, key) => {
                    return <MenuItem
                        key={key}
                        value={s.name}
                        sx={{
                            fontSize: "14px",
                            fontFamily: "Open Sans, sans-serif",
                            fontWeight: 400,
                            color: "#000000",
                        }}
                        data-geonameid={s.geonameId}
                    >{s.name}</MenuItem>
                })}
            </MUISelect>
        }
        if (comp.addressObjList === "city") {
            let cityList = [];
            cityList = getCityListByCounty(data[controleId], controleId);
            selectField = <MUISelect
                name={controleId}
                value={!data[controleId] ? "" : data[controleId]}
                label={comp.label}
                onChange={handeOnChange}
                disabled={isDisabled}
                sx={{
                    fontSize: "14px",
                    fontFamily: "Open Sans, sans-serif",
                    fontWeight: 400,
                    color: "#000000",
                    marginBottom: '18px',
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#555555",
                        color: "#555555",
                        opacity: 0.9,
                    },
                    "& .MuiInputLabel-root.Mui-disabled": {
                        color: "#333333",
                        opacity: 1,
                    },
                }}
            >
                <MenuItem
                    key={0}
                    value=""
                    sx={{
                        fontSize: "14px",
                        fontFamily: "Open Sans, sans-serif",
                        fontWeight: 400,
                        color: "#000000",
                    }}
                >None</MenuItem>
                {cityList.map((s, key) => {
                    return <MenuItem
                        key={key}
                        value={s.name}
                        data-geonameid={s.geonameId}
                        sx={{
                            fontSize: "14px",
                            fontFamily: "Open Sans, sans-serif",
                            fontWeight: 400,
                            color: "#000000",
                        }}
                    >{s.name}</MenuItem>
                })}
            </MUISelect>
        }
    }

    return (
        <FormControl fullWidth
            error={errors[controleId] ? true : false}
            disabled={isDisabled}
            required={comp.isRequired}
            className={`${comp?.cssclass ? "" : comp.cssclass}`}
            sx={{
                "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: "#555555",
                    color: "#555555",
                    opacity: 0.9,
                },
                "& .MuiInputLabel-root.Mui-disabled": {
                    color: "#333333",
                    opacity: 1,
                },
                "& .MuiInputBase-input": {
                    fontSize: "14px",
                    fontFamily: "Open Sans, sans-serif",
                    fontWeight: 400,
                    color: "#000000",
                    backgroundColor: `${!data[controleId] ? "#f0f0f0" : "#ffffff"}`,
                },
                "& .MuiInputLabel-root": {
                    fontSize: "14px",
                    fontFamily: "Open Sans, sans-serif",
                    fontWeight: 400,
                    color: "#000000",
                },
                "& .MuiFormHelperText-root": {
                    fontSize: "14px!important",
                    fontFamily: "Open Sans, sans-serif",
                },
                "& .MuiFormLabel-asterisk": {
                    color: "red",
                },
            }}
        >
            <InputLabel sx={{
                fontSize: "14px",
                fontFamily: "Open Sans, sans-serif",
                fontWeight: 400,
                color: "#000000",
            }}
            >{comp.label}</InputLabel>
            {selectField}
            {errors[controleId] && <FormHelperText>{errors[controleId]}</FormHelperText>}
        </FormControl>
    )
}